module.exports = __webpack_public_path__ + "images/12e0015c505b505a05d8477f513849c3.png";